export default __webpack_public_path__ + "static/media/1915.9891d3d3.png";